import PropTypes from "prop-types";
import React from "react";
import { CheckmarkSquare, DismissSquare } from "../../../assets/icons";

const PlanningToWork = ({ WorkingWeekend }) => {
    const isActive = WorkingWeekend === true;
    const styles = {
        color: isActive ? "#1D7D2C" : "#C11919", // Green/60 or Red/60
        backgroundColor: isActive ? "#EBF5ED" : "#FDE8E8", // Green/10 or Red/10
    };

    const icon = isActive ? CheckmarkSquare : DismissSquare;
    const altText = isActive ? "Working on Weekend" : "Not Working on Weekend";
    const text = isActive ? "Yes" : "No";

    return (
        <span
            style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "5px",
            borderRadius: "4px",
            ...styles
            }}
        >
            <img src={icon} alt={altText} />
            {text}
        </span>
    );
};

PlanningToWork.propTypes = {
    WorkingWeekend: PropTypes.bool.isRequired,
};

export default PlanningToWork;
